module.exports = __webpack_public_path__ + "img/paper_download.0652d28b.svg";